import React from 'react';
import './LoadingScreen.css';

interface LoadingScreenProps {
  progress: {
    status: string;
    percentage: number;
  };
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ progress }) => {
  return (
    <div className="loading-screen">
      <div className="loading-container">
        <div className="loading-logo">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" 
              fill="#E53E3E" stroke="#E53E3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h1>Initializing Canada Innovation Chatbot</h1>
        
        <div className="loading-progress-container">
          <div 
            className="loading-progress-bar" 
            style={{ width: `${progress.percentage}%` }}
          ></div>
        </div>
        
        <div className="loading-status">{progress.status}</div>
        
        <div className="loading-info">
          <p>Loading knowledge base from Supabase...</p>
          <ul>
            <li className={progress.percentage >= 30 ? "completed" : ""}>Initializing embeddings model</li>
            <li className={progress.percentage >= 50 ? "completed" : ""}>Loading document chunks</li>
            <li className={progress.percentage >= 70 ? "completed" : ""}>Processing image data</li>
            <li className={progress.percentage >= 90 ? "completed" : ""}>Building vector store</li>
            <li className={progress.percentage >= 100 ? "completed" : ""}>System ready</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen; 